/**
 * Discount React Query keys — a LEAF module on purpose.
 *
 * `useDiscounts` imports `invoiceKeys` from `useInvoices`, and `useInvoices` needs
 * these keys (an invoice line edit re-derives every discount amount on the server,
 * 2026-09-24), so defining them in either hook file would close an import cycle.
 * `useDiscounts` re-exports them, so existing imports are unchanged.
 */
import type { GetCustomDiscountsParams, GetStatsParams } from '../types/discount.types';

export const discountKeys = {
  all: ['discounts'] as const,
  settings: () => [...discountKeys.all, 'settings'] as const,
  customs: () => [...discountKeys.all, 'customs'] as const,
  customsList: (filters: GetCustomDiscountsParams) =>
    [...discountKeys.customs(), 'list', filters] as const,
  custom: (id: string) => [...discountKeys.customs(), id] as const,
  preview: (invoiceId: string) =>
    [...discountKeys.all, 'preview', invoiceId] as const,
  audit: (invoiceId: string) => [...discountKeys.all, 'audit', invoiceId] as const,
  stats: (params?: GetStatsParams) =>
    [...discountKeys.all, 'stats', params] as const,
  pending: () => [...discountKeys.all, 'pending'] as const,
  invoiceDetails: (invoiceId: string) =>
    [...discountKeys.all, 'invoiceDetails', invoiceId] as const,
};
